import { SET_LAUNCHER_TEXT, SET_VERSION_TEXT, SET_PATCH_NOTES, SET_TEXTS } from './constants'

export function setLauncherText(text) {
    return {
        type: SET_LAUNCHER_TEXT,
        payload: text,
    }
}

export function setVersionText(text) {
    return {
        type: SET_VERSION_TEXT,
        payload: text,
    }
}

export function setPatchNotes(text) {
    return {
        type: SET_PATCH_NOTES,
        payload: text,
    }
}

export function setTexts(texts) {
    return {
        type: SET_TEXTS,
        payload: texts,
    }
}



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/texts/actions.js